export const GOOGLE_PLACE_TYPES = [
  'supermarket',
  'convenience_store',
  'bakery',
  'restaurant',
] as const
export type GooglePlaceType = (typeof GOOGLE_PLACE_TYPES)[number]
